import * as React from 'react';
import { clsx } from 'clsx';
import { ArticleHeading4, Outside, Responsive } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';

import * as style from './style.css';

export interface IReviewsSortLayoutProps {
  title: React.ReactElement;
  sortButton: React.ReactElement;
  children: React.ReactElement;
  isOpen: boolean;
  onClose: () => void;
}

export const ReviewsSortLayout: React.FC<IReviewsSortLayoutProps> = ({
  title,
  sortButton,
  children,
  isOpen,
  onClose,
}) => {
  return (
    <div className={style['container']}>
      <Responsive desktop>{title}</Responsive>

      <Outside onOutside={onClose}>
        <div className={style['dropdown']}>
          {sortButton}

          <div className={clsx(style['options'], isOpen && style['opened'])}>
            <Responsive phone tablet>
              <div className={style['close']} onClick={onClose}>
                <div>
                  <ArticleHeading4 color="text-primary-default">Сортировка</ArticleHeading4>
                </div>
                <div>
                  <IconActionClose12 />
                </div>
              </div>
            </Responsive>

            {children}
          </div>
        </div>
      </Outside>
    </div>
  );
};
